import * as React from 'react';
import {
    Alert,
    Box,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import {
    useTranslate,
} from 'react-admin';
import CampaignExportButton from './CampaignExportButton';
import { useCampaignResponses } from './useCampaignResponses';

const CampaignResponses = () => {
    const translate = useTranslate();
    const { data: rows, error } = useCampaignResponses();

    if (error)
        return (
            <Alert severity="error">
                {translate('resources.campaign.responses_error')}
            </Alert>
        );
    if (!rows) return <CircularProgress />;

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                <CampaignExportButton />
                <CampaignExportButton allResponses />
            </Box>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{translate('resources.campaign.fields.user_name')}</TableCell>
                        <TableCell>{translate('resources.campaign.fields.user_guid')}</TableCell>
                        <TableCell>{translate('resources.campaign.fields.status')}</TableCell>
                        <TableCell>{translate('resources.campaign.fields.school_name')}</TableCell>
                        <TableCell>{translate('resources.campaign.fields.school_guid')}</TableCell>
                        <TableCell>{translate('resources.campaign.fields.selected_books')}</TableCell>
                        <TableCell>{translate('resources.campaign.fields.responded_at')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                        <TableRow key={row.user_guid}>
                            <TableCell>{row.user_name || '—'}</TableCell>
                            <TableCell>{row.user_guid}</TableCell>
                            <TableCell>
                                {translate(`resources.campaign.status.${row.status}`)}
                            </TableCell>
                            <TableCell>{row.school_name || '—'}</TableCell>
                            <TableCell>{row.school_guid || '—'}</TableCell>
                            <TableCell>{row.selected_books?.join(', ') || '—'}</TableCell>
                            <TableCell>
                                {row.responded_at
                                    ? new Date(row.responded_at).toLocaleString('fi-FI', {
                                          timeZone: 'Europe/Helsinki',
                                      })
                                    : '—'}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
};

export default CampaignResponses;
